import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import {
	CATEGORY_TYPE,
	SELECT_CF_TYPE,
	EPIC_STATUS_TYPE,
} from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import { transformAggNodeToLegacyField } from './default-node-transformer.tsx';

// @ts-expect-error TODO JPX-157
const getField = (node, customType) => {
	const value =
		node.fieldOption != null
			? {
					ari: node.fieldOption.id,
					id: node.fieldOption.optionId,
					value: node.fieldOption.value,
				}
			: null;

	return {
		...transformAggNodeToLegacyField(node),
		value,
		schema: {
			type: 'option',
			renderer: PLAIN_TEXT,
			custom: customType || node.type,
			system: null,
			items: null,
			configuration: null,
		},
	};
};

export const transformAggSingleSelectToLegacyField: FieldTransformer = (node) => {
	switch (node.type) {
		case EPIC_STATUS_TYPE:
		case SELECT_CF_TYPE: {
			// @ts-expect-error TODO JPX-157
			return getField(node);
		}
		case CATEGORY_TYPE: {
			return getField(node, SELECT_CF_TYPE);
		}
		default:
			return undefined;
	}
};
